// React and related hooks
import { useEffect } from 'react';

// i18n for translations
import { useTranslation } from 'react-i18next';

// Types and Enums
import { LanguageCodes } from '../common/types/i18n';

// Redux hooks and selectors
import { useAppSelector } from '../redux/hooks/useAppSelector';
import { selectIsDarkMode } from '../redux/selectors/displaySettingsSelectors';

export const useSetupAppDisplaySettings = () => {
  const isDarkMode = useAppSelector(selectIsDarkMode);
  const { i18n } = useTranslation();

  useEffect(() => {
    const applySettings = () => {
      document.documentElement.classList.toggle('dark', isDarkMode);
      document.body.classList.toggle('dark', isDarkMode);
      document.documentElement.dir =
        i18n.language === LanguageCodes.AR ? 'rtl' : 'ltr';
    };

    applySettings();
  }, [isDarkMode, i18n.language]);
};
